import * as React from 'react'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import { useTranslation } from 'react-i18next'

type PersonEmailToggleButtonProps = {
  value: 'person' | 'email'
  onChange: (event: React.MouseEvent<HTMLElement>, newContactType: 'person' | 'email') => void
}

const PersonEmailToggleButton: React.FC<PersonEmailToggleButtonProps> = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <ToggleButtonGroup exclusive value={value} onChange={onChange} aria-label="text alignment">
      <ToggleButton value="person" sx={{ px: 3, py: 1 }}>
        {t('person')}
      </ToggleButton>
      <ToggleButton value="email" sx={{ px: 3, py: 1 }}>
        {t('general')}
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default PersonEmailToggleButton
